import graphql__cfb65a5d107d4f69af77 from "./__generated__/MapEventMarker_element.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { Marker } from "react-leaflet";

import MapTooltip from "../MapTooltip";
import MapEventMarkerTooltip from "./MapEventMarkerTooltip";
import MapElementIcon from "../MapElementIcon";
import { useNavigateTo } from "../../Routes/RoutesContext";
import { useMapContext } from "../MapContext";
import { useSelector } from "react-redux";

const MapEventMarker = props => {
  const element = useFragment(MapEventMarker_element, props.element);
  const { eventsListId, style, latitude, longitude, event } = element;
  const { slug: eventSlug } = event;

  const { mapKey, mapPathFor } = useMapContext();
  const navigateTo = useNavigateTo();

  const handleMarkerClicked = useCallback(() => {
    navigateTo(mapPathFor("event", { eventSlug }));
  }, [eventSlug, mapPathFor, navigateTo]);

  const activeEventsListId = useSelector(
    ({ map }) => map[mapKey].filters.activeEventsListId
  );

  // Do not render filtered out events
  const isFilteredOut = activeEventsListId && activeEventsListId !== eventsListId;
  // Do not render unlocated events
  const hasPosition = latitude && longitude;

  if (isFilteredOut || !hasPosition) return null;

  const position = [latitude, longitude];
  const icon = MapElementIcon(style);

  return (
    <Marker
      className="map-debate-contribution"
      icon={icon}
      position={position}
      eventHandlers={{ click: handleMarkerClicked }}
    >
      <MapTooltip sticky={true} opacity={1}>
        <MapEventMarkerTooltip participativeModule={event} />
      </MapTooltip>
    </Marker>
  );
};

const MapEventMarker_element = graphql__cfb65a5d107d4f69af77;

export default MapEventMarker;
